import React from 'react'
import { navigate } from 'gatsby'
import { Container, Col, Row, Button } from '@paypalcorp/pp-react'

import GroupIcon from '../../../../icons/groupIcon'
import data from '../../../../content/home/home.en-XC.yaml'
import withAnalytics from '../../../../../utils/withAnalytics'

import './style.css'

const HomeFooter = ({ fpti }) => {
  const { footerLinks } = data.content.footer || []
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga

  const handleClick = () => {
    if (fptiData) {
      fpti.record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.page,
          e: 'cl',
          link: 'footer_support',
        },
      })
    }
    if (gaData) {
      gaData('send', 'event', 'footer_support', 'click', {})
    }
    navigate('/docs/support/', { replace: false })
  }

  return (
    <section className="footerSection">
      <Container>
        <Row>
          <Col xs={12} lg={8} className="floatCol">
            <h3 className="footerHeader">Looking for something else?</h3>
            <p className="footerBody">
              If you need additional help, check out our support articles,
              community resources, and more.
            </p>
            <div className="buttonWrapper">
              <Button theme="v2" onClick={handleClick}>
                Find support
              </Button>
            </div>
            <div className="footerLinks">
              <ul className="footerLinks-list">
                {footerLinks.map((link, key) => {
                  return (
                    <li
                      key={key}
                      className={
                        link.title === 'Docs Archive' ? 'lastFooter-link' : ''
                      }
                    >
                      <a
                        className="footerLinks-link"
                        href={link.url}
                        target={
                          link.url &&
                          link.url.startsWith('http') &&
                          !link.url.includes('developer.paypal.com')
                            ? '_blank'
                            : '_self'
                        }
                        rel="noreferrer"
                      >
                        {link.title}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </Col>
          <Col xs={12} lg={4} className="floatCol">
            <div className="group-image">
              <GroupIcon />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default withAnalytics(HomeFooter)
